/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EtlTenants } from '../models/EtlTenants';
import type { EtlTenantStatusesRequest } from '../models/EtlTenantStatusesRequest';
import type { SFTPDataSourceInternalResponse } from '../models/SFTPDataSourceInternalResponse';
import type { SurveySelections } from '../models/SurveySelections';
import type { UsersByPermissionsRequest } from '../models/UsersByPermissionsRequest';
import type { UsersByPermissionsResponse } from '../models/UsersByPermissionsResponse';
import type { WorkdayPullContextRequest } from '../models/WorkdayPullContextRequest';
import type { WorkdayPullContextResponse } from '../models/WorkdayPullContextResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalService {

    /**
     * Get list of companyJobs that don't exist in tenant's db
     * @returns string Success
     * @throws ApiError
     */
    public static getMissingJobCodes({
        requestBody,
    }: {
        requestBody: {
            jobCodes: Array<string>;
        },
    }): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/getMissingJobCodes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of mismatched combination of Company Job Family / Subfamily
     * @returns any Success
     * @throws ApiError
     */
    public static getMismatchJobFamilies({
        requestBody,
    }: {
        requestBody: {
            jobFamilies: Array<{
                job_family: string;
                job_subfamily: string;
            }>;
        },
    }): CancelablePromise<Array<{
        job_family: string;
        job_subfamily: string;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/getMismatchJobFamilies',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of mismatched combination of Company Job Level / Category
     * @returns any Success
     * @throws ApiError
     */
    public static getMismatchJobLevels({
        requestBody,
    }: {
        requestBody: {
            jobLevels: Array<{
                job_category: string;
                job_level: string;
            }>;
        },
    }): CancelablePromise<Array<{
        job_category: string;
        job_level: string;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/getMismatchJobLevels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get SFTP Data Sources
     * @returns SFTPDataSourceInternalResponse Success
     * @throws ApiError
     */
    public static getSftpDataSources(): CancelablePromise<Array<SFTPDataSourceInternalResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/getSFTPDataSources',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Current Plan
     * @returns any Success
     * @throws ApiError
     */
    public static getCurrentPlan(): CancelablePromise<{
        /**
         * The ID of the current plan, or null if no current plan exists
         */
        planId?: number | null;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/getCurrentPlan',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Workday pull context (datasource + fresh OAuth token) for data-management worker
     * Returns the metadata + fresh Workday OAuth token that the
     * data-management workday-worker needs for a single RaaS pull.
     *
     * Designed to be deleted in v2 once the HRIS data structures move into
     * data-management and the worker reads its own config directly.
     *
     * @returns WorkdayPullContextResponse Success
     * @throws ApiError
     */
    public static workdayPullContext({
        requestBody,
    }: {
        requestBody: WorkdayPullContextRequest,
    }): CancelablePromise<WorkdayPullContextResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/hris/workdayPullContext',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Resolve users in a company who hold all of the given permissions
     * Service-to-service lookup used by the notifications worker to resolve a
     * permission-based audience into recipient user ids.
     *
     * Resolves the company's tenant database from the global registry, then
     * returns the ids of users in that company holding all of the given
     * permissions (AND semantics). Returns an empty list when no user matches.
     *
     * @returns UsersByPermissionsResponse Success
     * @throws ApiError
     */
    public static usersByPermissions({
        requestBody,
    }: {
        requestBody: UsersByPermissionsRequest,
    }): CancelablePromise<UsersByPermissionsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/users/byPermissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Codes of active companies with analytics ETL enabled
     * @returns EtlTenants Success
     * @throws ApiError
     */
    public static getEtlTenants(): CancelablePromise<EtlTenants> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/etl/tenants',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Record what the DMS reconciler observed for each tenant schema
     * @returns any Success
     * @throws ApiError
     */
    public static putEtlTenantStatuses({
        requestBody,
    }: {
        requestBody: EtlTenantStatusesRequest,
    }): CancelablePromise<{
        updated: number;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal/etl/tenants/status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Customer selections on a survey's rows, per tenant
     * Service-to-service lookup used by the DataHub survey loader before it publishes a reload.
     *
     * Counts the composite data cuts (customer selections) on the survey in every active tenant,
     * grouped by survey row (unique ID and survey data id). The loader blocks a reload that would
     * remove a row listed here, because the next survey sync would delete those selections.
     *
     * @returns SurveySelections Success
     * @throws ApiError
     */
    public static getSurveySelections({
        surveyId,
    }: {
        /**
         * DataHub survey ID
         */
        surveyId: string,
    }): CancelablePromise<SurveySelections> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/surveys/{surveyId}/selections',
            path: {
                'surveyId': surveyId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
